import { render, staticRenderFns } from "./payoutBatchModify.vue?vue&type=template&id=96ee6678&scoped=true"
import script from "./payoutBatchModify.vue?vue&type=script&lang=ts"
export * from "./payoutBatchModify.vue?vue&type=script&lang=ts"
import style0 from "./payoutBatchModify.vue?vue&type=style&index=0&id=96ee6678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ee6678",
  null
  
)

export default component.exports